import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CorrespondenceActionPartyActions from './action-party.actions';
import { CorrespondenceActionPartyService } from '../../services/action-party.service';

@Injectable()
export class CorrespondenceActionPartyEffects {
  loadCorrespondenceActionParty$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceActionPartyActions.loadCorrespondenceActionParty),
      exhaustMap((_) =>
        this.correspondenceActionPartyService
          .getCorrespondenceActionParty()
          .pipe(
            map((data) =>
              CorrespondenceActionPartyActions.loadCorrespondenceActionPartySuccess(
                { correspondenceActionParty: data }
              )
            ),
            catchError((error) =>
              of(
                CorrespondenceActionPartyActions.loadCorrespondenceActionPartyFailure(
                  { error }
                )
              )
            )
          )
      )
    )
  );

  addCorrespondenceActionParty$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceActionPartyActions.addCorrespondenceActionParty),
      concatMap(({ newCorrespondenceActionParty }) =>
        this.correspondenceActionPartyService
          .createCorrespondenceActionParty(newCorrespondenceActionParty)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return CorrespondenceActionPartyActions.addCorrespondenceActionPartySuccess(
                {
                  newCorrespondenceActionParty: data,
                }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceActionPartyActions.addCorrespondenceActionPartyFailure(
                  { error: error.error.message }
                )
              )
            )
          )
      )
    )
  );

  updateCorrespondenceActionParty$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceActionPartyActions.updateCorrespondenceActionParty),
      map((action) => action.updateCorrespondenceActionParty),
      concatMap((updateCorrespondenceActionParty) =>
        this.correspondenceActionPartyService
          .updateCorrespondenceActionParty(updateCorrespondenceActionParty)
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return CorrespondenceActionPartyActions.updateCorrespondenceActionPartySuccess(
                {
                  updateCorrespondenceActionParty: updateCorrespondenceActionParty,
                }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceActionPartyActions.updateCorrespondenceActionPartyFailure(
                  { error: error.message }
                )
              )
            )
          )
      )
    )
  );

  removeCorrespondenceActionParty$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceActionPartyActions.removeCorrespondenceActionParty),
      map((action) => action.ids),
      concatMap((ids) =>
        this.correspondenceActionPartyService
          .deleteCorrespondenceActionParty(ids)
          .pipe(
            map(() => {
              this.notification.success('Deleted Successfully');
              return CorrespondenceActionPartyActions.removeCorrespondenceActionPartySuccess(
                { ids }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceActionPartyActions.updateCorrespondenceActionPartyFailure(
                  { error: error.message }
                )
              )
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private correspondenceActionPartyService: CorrespondenceActionPartyService,
    private notification: NotificationService
  ) {}
}
